"use client";
import React, { useEffect, useRef, useState } from "react";
import Typed from "typed.js";

const TerminalBlock = () => {
  const el = useRef(null);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        `const <span class="text-cyan-400">developer</span> = {
  <span class="text-violet-300">name</span>: <span class="text-emerald-300">"Eslam Ahmed"</span>,
  <span class="text-violet-300">role</span>: <span class="text-emerald-300">"Frontend Developer"</span>,
  <span class="text-violet-300">stack</span>: [
    <span class="text-emerald-300">"React"</span>,
    <span class="text-emerald-300">"Next.js"</span>,
    <span class="text-emerald-300">"TypeScript"</span>
  ],
  <span class="text-violet-300">backend</span>: <span class="text-emerald-300">"ASP.NET Core"</span>,
  <span class="text-violet-300">shipping</span>: <span class="text-emerald-300">"SaaS + GRC"</span>
};`,
        `<span class="text-violet-300">await</span> <span class="text-cyan-400">buildUI</span>({
  <span class="text-violet-300">accessible</span>: <span class="text-amber-300">true</span>,
  <span class="text-violet-300">performance</span>: <span class="text-amber-300">"lighthouse+30%"</span>,
  <span class="text-violet-300">stack</span>: <span class="text-emerald-300">"React / Next"</span>
});`,
      ],
      typeSpeed: 28,
      backSpeed: 16,
      backDelay: 1800,
      loop: true,
      showCursor: false,
      autoInsertCss: true,
    });

    return () => typed.destroy();
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(el.current?.textContent || "");
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  return (
    <div className="relative h-[22rem] w-full rounded-xl border border-white/10 bg-neutral-950/80 text-neutral-300 shadow-2xl backdrop-blur-xl overflow-hidden">
      <div className="border-b border-white/10 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="h-3 w-3 rounded-full bg-red-500" />
          <span className="h-3 w-3 rounded-full bg-yellow-400" />
          <button
            type="button"
            aria-label="Copy code"
            className="h-3 w-3 rounded-full bg-green-500 hover:bg-green-400"
            onClick={handleCopy}
          />
        </div>
        <span className="text-xs text-neutral-400 font-mono">developer.ts</span>
        <span className="text-xs text-emerald-400 font-mono w-14 text-right">
          {isCopied ? "Copied" : "TS"}
        </span>
      </div>

      <div className="p-4 h-[calc(100%-48px)] font-mono text-sm leading-relaxed">
        <div className="flex items-center text-neutral-500 mb-3">
          <span className="mr-2 text-violet-400">➜</span>
          <span className="text-cyan-400">~/portfolio</span>
        </div>
        <span
          ref={el}
          className="whitespace-pre-wrap text-[13px] md:text-sm"
        />
      </div>
    </div>
  );
};

export default TerminalBlock;
